import React, { useContext } from 'react'
import loadable from '@loadable/component'
import { createRenderTarget } from '../render-target'
import { useTheme } from '@emotion/react'
import { AppState, Product, useFeature } from '@news-mono/web-common'
import { EntitledToView } from '../user-registration/entitlements/EntitledToView'
import { ConfigurationContext } from '@news-mono/web-common'
import { CommentEvent } from '@news-mono/web-common'
import { TextLink } from '../typography/TextLink/TextLink'
import { MessageBanner } from '../banners/MessageBanner/MessageBanner'
import { ContentSeparator } from '../content/ContentSeparator/ContentSeparator.styled'
import { ThemeMargins } from '../__styling/settings/metrics'
import { useSelector } from 'react-redux'

export const LazyCoral = loadable(() => import('./Coral.web'))

const CoralRender = createRenderTarget('Coral', {
    web: LazyCoral,
    amp: null,
    rss: null,
    preview: null,
    app: LazyCoral,
})

export interface CoralProps {
    storyID?: string
    articleCommentsEnabled?: boolean
    horizontalSpacing?: keyof ThemeMargins
    onEvent: (event: CommentEvent) => void
}

export const Coral: React.FC<CoralProps> = ({
    storyID,
    articleCommentsEnabled,
    horizontalSpacing,
    onEvent,
}) => {
    const { coralUrl } = useContext(ConfigurationContext)
    const { subscriptionType } = useSelector(
        (state: AppState) => state.authentication,
    )
    const { section, kind } = useTheme()
    const areCommentsEnabled = useFeature('comments')
    const canShowComments =
        areCommentsEnabled &&
        articleCommentsEnabled &&
        kind === Product.TheWest &&
        section === 'default' &&
        subscriptionType !== 'corporate-site'

    if (!canShowComments || typeof coralUrl === 'undefined') {
        return null
    }

    return (
        <EntitledToView
            requiredAccess={{ level: 'subscriber' }}
            entitled={() => (
                <CoralRender
                    coralScriptUrl={coralUrl}
                    storyID={storyID}
                    onEvent={onEvent}
                    horizontalSpacing={horizontalSpacing}
                />
            )}
            notEntitled={() => (
                <React.Fragment>
                    <MessageBanner
                        icon="comment"
                        id="coral_thread"
                        onEvent={onEvent}
                    >
                        <p>
                            To comment on this story and join the conversation,
                            subscribe to The West Australian’s{' '}
                            <TextLink href="https://subscriber.thewest.com.au/subscribenow/digital?utm_source=TheWest&utm_medium=Article-Block&utm_campaign=Comments&utm_term=subscribe&utm_content=login">
                                Everyday Digital package
                            </TextLink>
                            .
                        </p>
                    </MessageBanner>
                    <ContentSeparator verticalSpacing="lg" includeTopSpacing />
                </React.Fragment>
            )}
        />
    )
}
